<template>
    <div class="news-detail-container">
        <div class="news-detail-header">
            <h1>新闻资讯</h1>
        </div>

        <el-container class="main-content">
            <div class="back-button" @click="handleToNewMores">
                <img src="../../assets/img/fanhui.png" alt="" /> 返回
            </div>
            <div class="news-content">
                <h1 class="title">
                    {{ newsDetail.title }}
                </h1>
                <div class="meta-info">
                    <span class="date">{{ newsDetail.createTime }}</span>
                </div>
                <div class="content" v-html="newsDetail.content"></div>
            </div>
        </el-container>
    </div>
</template>

<script>
import { newsDetail } from "@/api/index";
export default {
    name: "NewsDetail",
    data() {
        return {
            newsDetail: {
                title: "",
                date: "",
                content: "",
            },
        };
    },
    created() {
        const newsId = this.$route.params.id;
        if (!newsId) {
            this.$message.error("新闻ID不存在");
            this.$router.push("/news");
            return;
        }
        this.getNewsDetail(newsId);
    },
    methods: {
        async getNewsDetail(id) {
            try {
                const res = await newsDetail({ id });
                if (res.data) {
                    this.newsDetail = res.data;
                }
            } catch (error) {
                console.error("获取新闻详情失败:", error);
                this.$message.error("获取新闻详情失败");
            }
        },
        handleToNewMores() {
            this.$router.go(-1);
        },
    },
};
</script>

<style scoped lang="scss">
.news-detail-container {
    background: linear-gradient(to bottom, #f2f2f2, #fefefe);

    .news-detail-header {
        color: white;
        height: 220px;
        padding: 30px 241px;
        border-radius: 4px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        background-image: url("../../assets/bg/xinwengbanner.png");
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
    }

    .news-detail-header h1 {
        margin: 0;
        font-size: 48px;
    }

    .main-content {
        padding: 66px 364px;
        background: #fff;
        position: relative;
        .back-button {
            position: absolute;
            left: 242px;
            top: 70px;
            transform: translateY(-50%);
            cursor: pointer;
            display: flex;
            align-items: center;
            color: #333;
            img {
                margin-right: 2px;
                width: 16px;
                height: 16px;
            }
        }

        .news-content {
            /* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1); */

            .title {
                font-size: 24px;
                color: #333;
                margin-bottom: 10px;
                margin-top: 0;
                text-align: center;
                font-weight: normal;
            }

            .meta-info {
                text-align: center;
                margin-bottom: 30px;

                .date {
                    color: #858484;
                    font-size: 14px;
                }
            }

            .content {
                font-size: 16px;
                line-height: 1.8;
                color: #666;

                p {
                    margin-bottom: 16px;
                }
            }
        }
    }
}
</style>
